/**
 * @generated SignedSource<<f23098a53dc66ada57a02a7722928afe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryTownPageQuery$variables = {
  areaSlug: string;
};
export type DirectoryTownPageQuery$data = {
  readonly landlordDirectoryArea: {
    readonly name: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DirectoryTownAgentList_area" | "DirectoryTownFeeSummary_area" | "DirectoryTownSeoHead_area" | "DirectoryTownV2Page_area">;
  } | null | undefined;
};
export type DirectoryTownPageQuery = {
  response: DirectoryTownPageQuery$data;
  variables: DirectoryTownPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "areaSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "areaSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleRating",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleReviewCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percent",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesIncludeVat",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sampleSize",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vatUnknownCount",
  "storageKey": null
},
v12 = [
  (v10/*:: as any*/),
  (v11/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "flatFeeCount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "medianPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumPercentIncVat",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v14 = [
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amountPence",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "LandlordDirectoryAgentFee",
  "kind": "LinkedField",
  "name": "management",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "LandlordDirectoryAgentFee",
  "kind": "LinkedField",
  "name": "rentCollection",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "LandlordDirectoryAgentFee",
  "kind": "LinkedField",
  "name": "letOnly",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "LandlordDirectoryAgentFee",
  "kind": "LinkedField",
  "name": "tenantFind",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DirectoryTownPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryArea",
        "kind": "LinkedField",
        "name": "landlordDirectoryArea",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownSeoHead_area"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownFeeSummary_area"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownAgentList_area"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryTownV2Page_area"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DirectoryTownPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryArea",
        "kind": "LinkedField",
        "name": "landlordDirectoryArea",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "LandlordDirectoryAgentConnection",
            "kind": "LinkedField",
            "name": "agents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleMapsUrl",
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "management",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sourceUrls",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentSources",
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "trustpilot",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*:: as any*/)
            ],
            "storageKey": "agents(first:100)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryFeeStats",
            "kind": "LinkedField",
            "name": "feeStats",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumManagementFeePercent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medianManagementFeePercent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maximumManagementFeePercent",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAreaStats",
            "kind": "LinkedField",
            "name": "stats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noFeesBranchCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatUnknownBranchCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medianGoogleRating",
                "storageKey": null
              },
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAreaPercentFeeStats",
                "kind": "LinkedField",
                "name": "management",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAreaPercentFeeStats",
                "kind": "LinkedField",
                "name": "rentCollection",
                "plural": false,
                "selections": (v12/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAreaLetOnlyFeeStats",
                "kind": "LinkedField",
                "name": "letOnly",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAreaLetOnlyFee",
                    "kind": "LinkedField",
                    "name": "fees",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "percentIncVat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountPenceIncVat",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "allAgents",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10000
              }
            ],
            "concreteType": "LandlordDirectoryAgentConnection",
            "kind": "LinkedField",
            "name": "agents",
            "plural": false,
            "selections": [
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v3/*:: as any*/),
                      (v2/*:: as any*/),
                      (v13/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v15/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "agents(first:10000)"
          },
          {
            "alias": "feeListAgents",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 500
              }
            ],
            "concreteType": "LandlordDirectoryAgentConnection",
            "kind": "LinkedField",
            "name": "agents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDirectoryAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v3/*:: as any*/),
                      (v2/*:: as any*/),
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDirectoryAgentFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v15/*:: as any*/),
                          (v16/*:: as any*/),
                          (v18/*:: as any*/),
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "renewal",
                            "plural": false,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "inventory",
                            "plural": false,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "managementWithTenantInPlace",
                            "plural": false,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentFee",
                            "kind": "LinkedField",
                            "name": "rentCollectionWithTenantInPlace",
                            "plural": false,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDirectoryAgentOtherFee",
                            "kind": "LinkedField",
                            "name": "otherFees",
                            "plural": true,
                            "selections": (v14/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "agents(first:500)"
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70f4c8b4f592bcdd428818d206ef1fae",
    "id": null,
    "metadata": {},
    "name": "DirectoryTownPageQuery",
    "operationKind": "query",
    "text": "query DirectoryTownPageQuery(\n  $areaSlug: String!\n) {\n  landlordDirectoryArea(slug: $areaSlug) {\n    name\n    ...DirectoryTownSeoHead_area\n    ...DirectoryTownFeeSummary_area\n    ...DirectoryTownAgentList_area\n    ...DirectoryTownV2Page_area\n    id\n  }\n}\n\nfragment DirectoryTownAgentCard_agent on LandlordDirectoryAgent {\n  slug\n  name\n  address\n  googleMapsUrl\n  googleRating\n  googleReviewCount\n  trustpilotRating\n  trustpilotReviewCount\n  fees {\n    management {\n      percent\n      sourceUrls\n    }\n    feesIncludeVat\n  }\n  sources {\n    trustpilot\n  }\n}\n\nfragment DirectoryTownAgentList_area on LandlordDirectoryArea {\n  agents(first: 100) {\n    totalCount\n    edges {\n      node {\n        id\n        ...DirectoryTownAgentCard_agent\n      }\n    }\n  }\n}\n\nfragment DirectoryTownAgentTableMobileRow_agent on LandlordDirectoryAgent {\n  slug\n  name\n  postcode\n}\n\nfragment DirectoryTownAgentTableRow_agent on LandlordDirectoryAgent {\n  slug\n  name\n  postcode\n}\n\nfragment DirectoryTownAgentTable_area on LandlordDirectoryArea {\n  stats @featureFlag(gate: \"directory_area_page_v2\") {\n    management {\n      sampleSize\n      minimumPercentIncVat\n      medianPercentIncVat\n      maximumPercentIncVat\n    }\n    rentCollection {\n      sampleSize\n      minimumPercentIncVat\n      medianPercentIncVat\n      maximumPercentIncVat\n    }\n    letOnly {\n      sampleSize\n      fees {\n        percentIncVat\n        amountPenceIncVat\n      }\n    }\n  }\n  allAgents: agents(first: 10000) @featureFlag(gate: \"directory_area_page_v2\") {\n    totalCount\n    edges {\n      node {\n        id\n        slug\n        name\n        postcode\n        googleRating\n        googleReviewCount\n        fees {\n          feesIncludeVat\n          management {\n            percent\n            amountPence\n          }\n          rentCollection {\n            percent\n            amountPence\n          }\n          letOnly {\n            percent\n            amountPence\n          }\n          tenantFind {\n            percent\n            amountPence\n          }\n        }\n        ...DirectoryTownAgentTableRow_agent\n        ...DirectoryTownAgentTableMobileRow_agent\n      }\n    }\n  }\n}\n\nfragment DirectoryTownFeeLists_area on LandlordDirectoryArea {\n  feeListAgents: agents(first: 500) @featureFlag(gate: \"directory_area_page_v2\") {\n    edges {\n      node {\n        id\n        slug\n        name\n        postcode\n        fees {\n          feesIncludeVat\n          management {\n            percent\n            amountPence\n          }\n          rentCollection {\n            percent\n            amountPence\n          }\n          tenantFind {\n            percent\n            amountPence\n          }\n          letOnly {\n            percent\n            amountPence\n          }\n          renewal {\n            percent\n            amountPence\n          }\n          inventory {\n            percent\n            amountPence\n          }\n          managementWithTenantInPlace {\n            percent\n            amountPence\n          }\n          rentCollectionWithTenantInPlace {\n            percent\n            amountPence\n          }\n          otherFees {\n            percent\n            amountPence\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DirectoryTownFeeSummary_area on LandlordDirectoryArea {\n  feeStats {\n    sampleSize\n    minimumManagementFeePercent\n    medianManagementFeePercent\n    maximumManagementFeePercent\n  }\n}\n\nfragment DirectoryTownHero_area on LandlordDirectoryArea {\n  agents(first: 100) {\n    totalCount\n  }\n  stats @featureFlag(gate: \"directory_area_page_v2\") {\n    noFeesBranchCount\n    vatUnknownBranchCount\n    medianGoogleRating\n    googleReviewCount\n    management {\n      sampleSize\n      vatUnknownCount\n      flatFeeCount\n      minimumPercentIncVat\n      medianPercentIncVat\n      maximumPercentIncVat\n    }\n    rentCollection {\n      sampleSize\n      vatUnknownCount\n      flatFeeCount\n      minimumPercentIncVat\n      medianPercentIncVat\n      maximumPercentIncVat\n    }\n    letOnly {\n      sampleSize\n      vatUnknownCount\n      fees {\n        percentIncVat\n        amountPenceIncVat\n      }\n    }\n  }\n}\n\nfragment DirectoryTownSeoHead_area on LandlordDirectoryArea {\n  agents(first: 100) {\n    edges {\n      node {\n        slug\n        id\n      }\n    }\n  }\n}\n\nfragment DirectoryTownV2Page_area on LandlordDirectoryArea {\n  name\n  ...DirectoryTownSeoHead_area\n  ...DirectoryTownHero_area\n  ...DirectoryTownAgentTable_area\n  ...DirectoryTownFeeLists_area\n}\n"
  }
};
})();

(node as any).hash = "1e7f8d9f0aee487ecbf2d38788440e65";

export default node;
